<template>
  <div class="content-tab aclmac">
    <loading :mask=true :size="'big'" :isWhite=true v-if="isShowLoading"/>
    <div class="content-body">
      <div class="content-item">
        <div class="content-body-header">
          <!-- <div class="forminput search icon-search">
            <input name="filterDetail" type="text" class="form-control filterInput" :placeholder="$t('search')" @change="onSearchClick" @keyup.enter="onSearchClick">
          </div>
          <div class="hr"/> -->
          <button class="q-button blue-btn-full footer-btn" @click="onActionClick('add')" :title="$t('add')">{{$t('add')}}</button>
        </div>
        <div class="group-table" v-if="!isEmpty">
          <fixed-table class="mac-address-table" ref="addressTable" :data="aclList" :use-page="false" :header-height="30" :show-count="10">
            <div class="right-header" slot="right-header">
                <column :id="$t('acl.number')" :title="this.$isOverflow($t('acl.number'))" style="width: 10%;" sort="no." :number="true">{{$t('acl.number')}}</column>
                <!-- <column style="width: 13%;" sort="direction" :number="true">{{$t('acl.direction')}}</column> -->
                <column style="width: 25%;" sort="sourceMAC">{{$t('acl.source')}}</column>
                <column style="width: 25%;" sort="destinationMAC">{{$t('acl.destination')}}</column>
                <column style="width: 18%;" sort="portList">{{$t('acl.port')}}</column>
                <column :id="$t('rule')" :title="this.$isOverflow($t('rule'))" style="width: 10%;" sort="action" :number="true">{{$t('rule')}}</column>
                <column style="width: 12%;">{{$t('action')}}</column>
            </div>
            <template slot="rows" slot-scope="props">
                <div class="link-row">
                    <row class="right" :props="props">
                        <div class="data" style="width: 10%;" :title="props.data.key | getKey">{{props.data.key | getKey}}</div>
                        <!-- <div class="data" style="width: 13%;" :title="(props.data.val.direction === 1) ? $t('acl.ingress') : $t('acl.egress')">{{(props.data.val.direction === 1) ? $t('acl.ingress') : $t('acl.egress')}}</div> -->
                        <div class="data" style="width: 25%;">{{getMAC(props.data.val.sourceMAC)}}</div>
                        <div class="data" style="width: 25%;">{{getMAC(props.data.val.destinationMAC)}}</div>
                        <div class="data" style="width: 18%;" :title="props.data.val.portList | getPort">{{props.data.val.portList | getPort}}</div>
                        <div class="data" style="width: 10%;">{{(props.data.val.action === 1) ? $t('acl.allow') : $t('acl.deny')}}</div>
                        <div class="data" style="width: 12%;">
                          <span class="icon-edit" @click="onActionClick('edit', props)" :title="$t('edit')"></span>
                          <span class="icon-trashcan" @click="onActionClick('delete', props.data)" :title="$t('delete')"></span>
                        </div>
                    </row>
                </div>
            </template>
          </fixed-table>
        </div>
        <div class="empty" v-else>
          <nodata/>
          <div class="content-text">{{$t('empty')}}</div>
        </div>
      </div>
      <acl-item type="mac" :selectObj=selectObj :isAdd=isAdd :onChange=getData :existNumber=existNumber />
      <popup-confirm name="security-modal" :dialog-header="$t('acl.deleteTitle')" :dialog-message="$t('acl.deleteContent')" icon="w" type="d" :callback="goDelete" />
      <popup-confirm name="warning-modal" :dialog-header="$t('warning')" :dialog-message="$t('acl.limit')" icon="w" :onlyOk=true ></popup-confirm>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import fixedTable from './table/FixedTable'
import row from './table/row/Row'
import column from './table/column/Column'
import AclItem from './AclItem'
import nodata from '../assets/svg/no_data.svg'
export default {
  name: 'AclMac',
  components: {
    fixedTable,
    row,
    column,
    AclItem,
    nodata
  },
  data () {
    return {
      aclList: [],
      modalTitle: '',
      selectObj: null,
      delObj: null,
      isAdd: true,
      isShowLoading: false,
      isEmpty: false,
      isLimit: false,
      existNumber: []
    }
  },
  created: function () {
    this.getData()
    let me = this
    window.addEventListener('resize', this.myEventHandler)
    setTimeout(() => {
      me.$forceUpdate()
    }, 500)
  },
  watch: {
    lang: {
      handler (value) {
        let me = this
        setTimeout(() => {
          me.$forceUpdate()
        }, 500)
      },
      immediate: true
    }
  },
  filters: {
    getKey (data) {
      return parseInt(data)
    },
    getPort (data) {
      let result = null
      if (data && data.length > 0) {
        data.forEach(element => {
          result === null ? result = parseInt(element) : result = result + ', ' + parseInt(element)
        })
      }
      return result
    }
  },
  methods: {
    ...mapActions(['getMACacl', 'delMACacl']),
    ...mapMutations([ 'openModal', 'closeModal' ]),
    getData: function () {
      let me = this
      this.isShowLoading = true
      this.aclList = []
      this.existNumber = []
      this.getMACacl()
        .then((res) => {
          if (res.data.error_code === 200) {
            this.aclList = res.data.result
            this.isShowLoading = false
            if (!this.aclList) {
              this.isEmpty = true
              this.aclList = []
            } else {
              this.isEmpty = false
              this.aclList.forEach(element => {
                this.existNumber.push(parseInt(element.key))
              })
            }
            setTimeout(() => {
              me.$forceUpdate()
            }, 500)
          } else {
            this.$log.debug(res.data)
          }
        })
    },
    getMAC: function (item) {
      if (item === '00:00:00:00:00:00') {
        return this.$t('acl.any')
      } else {
        return item
      }
    },
    getNextId: function () {
      let number = 1
      let isMissNumber = false
      for (var index = 0; index < this.aclList.length; index++) {
        if (!isMissNumber) {
          if (parseInt(this.aclList[index].key) !== index + 1) {
            number = index + 1
            isMissNumber = true
          }
        }
      }
      if (!isMissNumber) {
        number = this.aclList.length + 1
      }
      return number
    },
    onActionClick: function (item, editData) {
      if (item === 'delete') {
        this.isAdd = false
        this.delObj = editData
        this.openModal('security-modal')
        this.$modal.show('security-modal')
      } else if (item === 'add') {
        if (this.aclList.length < 256) {
          let number = this.getNextId()
          this.isAdd = true
          this.modalTitle = this.$t('acl.addMacTitle')
          this.selectObj = {
            index: this.aclList.length + 1,
            number: number
          }
          this.openModal('acl-config-modal')
          this.$modal.show('acl-config-modal')
        } else {
          this.openModal('warning-modal')
          this.$modal.show('warning-modal')
        }
      } else if (item === 'edit') {
        this.isAdd = false
        this.selectObj = editData
        this.modalTitle = this.$t('acl.editMacTitle')
        this.openModal('acl-config-modal')
        this.$modal.show('acl-config-modal')
      }
    },
    goDelete: function () {
      this.delMACacl(this.delObj.key)
        .then((result) => {
          this.$modal.hide('security-modal')
          if (result.data.error_code === 200) {
            this.getData()
          } else {
            this.$log.debug(result.data)
          }
        })
    },
    onHelpClick: function () {
      this.$store.commit('updateQuickHelp', !this.showQuickHelp)
    },
    // TODO:
    onSearchClick: function () {
      let me = this
      let selList = []
      this.filterList = this.tempList
      if (!me.filterDetail) {
        this.addressList = this.tempList
      } else {
        for (const index in this.filterList) {
          if (this.filterList.hasOwnProperty(index)) {
            const element = this.filterList[index]
            if (me.filterType === 'vlanId') {
              if (element.key[0] === parseInt(me.filterDetail)) {
                selList.push(element)
              }
            } else if (me.filterType === 'macAddress') {
              if (element.key[1] === me.filterDetail) {
                selList.push(element)
              }
            } else if (me.filterType === 'type') {
              if (element.val.Dynamic === me.checkDynamic(me.filterDetail)) {
                selList.push(element)
              }
            } else {
              let port = 'Gi 1/' + me.filterDetail
              if (element.val.Port.indexOf(port) > -1) {
                selList.push(element)
              }
            }
          }
        }
        this.addressList = selList
      }
      if (this.addressList.length > 0) {
        me.isEmpty = false
      } else {
        me.isEmpty = true
      }
    },
    myEventHandler (e) {
      this.$forceUpdate()
    }
  },
  computed: {
    ...mapState({
      lang: state => state.app.lang,
      showQuickHelp: state => state.app.showQuickHelp
    })
  }
}
</script>

<style lang="scss" scoped>

.aclmac {
  position: relative;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  >.content-body {
    .content-item {
      position: relative;
      padding: 0px 20px;
      height: 100%;
      margin-bottom: 0px;
    }
    .content-body-header {
      padding: 10px 0px;
      display: flex;
      justify-content: flex-end;
    }
    .right {
      float: right;
    }
    .group-table {
      height: calc(100% - 70px);
      .data {
        text-overflow: ellipsis;
        /* Required for text-overflow to do anything */
        white-space: nowrap;
        overflow: hidden;
      }
    }
    .empty {
      text-align: center;
      svg {
        width: 150px;
        height: 150px;
      }
      >div {
        margin: auto;
        font-family: 'Roboto-M' !important;
        font-size: 16px;
      }
    }
    .icon-trashcan {
      margin-left: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AclMac.vue